<template>
    <div class="ssv-order__participant-form">
        <div class="input-item">
            <label class="label" :for="getUniqueId('name')">Křestní jméno</label>
            <input class="input input--l" :id="getUniqueId('name')" type="text" :value="participant.name" name="name" v-on:change="changeField">
            <ssv-order-error-field :field="getUniqueId('name')"/>
        </div>

        <div class="input-item">
            <label class="label" :for="getUniqueId('surname')">Příjmení</label>
            <input class="input input--l" :id="getUniqueId('surname')" type="text" :value="participant.surname" name="surname"
                   v-on:change="changeField">
            <ssv-order-error-field :field="getUniqueId('surname')"/>
        </div>

        <div class="input-item">
            <label class="label" :for="getUniqueId('email')">E-mail</label>
            <input class="input input--l" :id="getUniqueId('email')" type="text" :value="participant.email" name="email"
                   v-on:change="changeField">
            <ssv-order-error-field :field="getUniqueId('email')"/>
        </div>

        <div class="input-item">
            <label class="label" :for="getUniqueId('phone')">Telefon</label>
            <input class="input input--m" :id="getUniqueId('phone')" type="phone" :value="participant.phone" name="phone"
                   v-on:change="changeField">
            <ssv-order-error-field :field="getUniqueId('phone')"/>
        </div>

        <div class="input-item" v-if="shirtAvailable">
            <label class="label" :for="getUniqueId('shirt')">Velikost trika</label>
            <select class="input input--m" :id="getUniqueId('shirt')" :value="participant.additionalData.shirt || 0" name="shirt"
                    v-on:change="changeShirt">
                <option :value="0" disabled>Vyberte</option>
                <option v-for="option in options.shirt" :value="option.id">{{option.name}}</option>
            </select>
            <ssv-order-error-field :field="getUniqueId('shirt')"/>
        </div>
        <div class="input-item" v-if="distributors">
            <label class="label" :for="getUniqueId('role')">Funkce</label>
            <select class="input input--m" :id="getUniqueId('role')" :value="participant.additionalData.role || 0" name="roles"
                    v-on:change="changeRoles">
                <option :value="0" disabled>Vyberte</option>
                <option v-for="option in options.role" :value="option.id">{{option.name}}</option>
            </select>
            <ssv-order-error-field :field="getUniqueId('role')"/>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import SsvOrderErrorField from '../error/ErrorField';

export default {
    name:       'SsvOrderParticipantForm',
    components: {
        SsvOrderErrorField
    },
    computed:   {
        ...mapGetters('ssvOrder', ['participantByIndex']),
        participant() {
            return this.participantByIndex(this.index);
        }
    },
    data() {
        return {
            options: {
                shirt: [
                    { id: 'M', name: 'M' },
                    { id: 'L', name: 'L' },
                    { id: 'XL', name: 'XL' },
                    { id: 'XXL', name: 'XXL' },
                ],
                role: [
                    { id: 'seller-clerk', name: 'prodejce / referent' },
                    { id: 'salesman', name: 'obchodní zástupce' },
                ]
            }
        }
    },
    props:   {
        index:               Number,
        shirtAvailable: {
            type:    Boolean,
            require: false,
            default: () => false,
        },
        distributors:        {
            type:    Boolean,
            require: false,
            default: () => false,
        },
    },
    methods: {
        ...mapActions('ssvOrder', ['setParticipantField']),
        getUniqueId(name) {
            return 'participant.' + this.index + '.' + name;
        },
        changeField({ target: { name, value } }) {
            this.setParticipantField({ index: this.index, name, value });
        },
        changeShirt({ target: { value } }) {
            this.setParticipantField({ index: this.index, name: 'additionalData', value: { shirt: value } });
        },
        changeRoles({ target: { value } }) {
            this.setParticipantField({ index: this.index, name: 'additionalData', value: { role: value } });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/participant/ParticipantForm.vue